/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Financial/view.blocks to change it.
import Content from './Content/index'
import React from 'react'
import Tabs from './Tabs/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'



/** @type {import('Simple/types.js').View} */
export default function Financial({
  children,
  viewPath = "/App/Account/Content/Financial"
  
}) {
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 flexDirection="column"
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 overflowX="hidden"
 overflowY="hidden"
>
{childProps => (
<React.Fragment>
<Tabs
{...childProps}
  viewPath={`${viewPath}/Tabs`}
/>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}